import axios from "axios";

/** Kept in step with math-server tutorialAnalyticsLog.ts */
export const TUTORIAL_ANALYTICS_EVENTS = [
  "tutorial_modal_open",
  "tutorial_modal_watch",
  "tutorial_modal_skip",
  "tutorial_modal_got_it",
  "tutorial_open",
] as const;

export type TutorialAnalyticsEvent = (typeof TUTORIAL_ANALYTICS_EVENTS)[number];

export const HELP_WORKS_MARK_ID = "practice-assist-modes";

/**
 * Fire-and-forget. A failed post must not change the click the user just made.
 * The axios interceptor already attaches the guest id or the session token.
 */
export function trackTutorialEvent(
  event: TutorialAnalyticsEvent,
  extra?: { videoId?: string; markId?: string },
): void {
  if (typeof window === "undefined") return;
  const lang = document.documentElement.lang;
  void axios
    .post("/api/analytics/tutorial", {
      event,
      path: window.location.pathname || "/",
      locale: lang === "he" ? "he" : "en",
      ...(extra?.videoId ? { videoId: extra.videoId } : {}),
      ...(extra?.markId ? { markId: extra.markId } : {}),
    })
    .catch(() => {});
}
